export enum EmployeePermissionsEnum {
  BACKGROUND_CHECK_ADMIN = 'BACKGROUND_CHECK__ADMIN',
  BACKGROUND_CHECK_REVIEW = 'BACKGROUND_CHECK__REVIEW',
  BACKGROUND_CHECK_REQUEST = 'BACKGROUND_CHECK__REQUEST',
  HR_ADMIN = 'HR__ADMIN',
  HR_REVIEW = 'HR__REVIEW',
  HR_REQUEST = 'HR__REQUEST',
  I9_ADMIN = 'I9__ADMIN',
  I9_REVIEW = 'I9__REVIEW',
  I9_REQUEST = 'I9__REQUEST',
}

export enum PermissionGroupKey {
  BACKGROUND_CHECK = 'backgroundCheck',
  HR_FORM = 'hrForm',
  I9 = 'i9',
}
